let json = {
	"id": 3,
	"sort": null,
	"createTime": "2017-03-05 14:15:00",
	"updateTime": "2017-03-06 09:00:16",
	"name": "预览框架皮肤",
	"description": "这是一个专门提供用来预览框架皮肤的菜单。",
	"type": "ARTICLE",
	"articleId": 1,
	"sceneryId": null,
	"location": "preview",
	"status": "OK",
	"menus": [{
		"name": "链接文章1",
		"level": 0,
		"articleId": 2,
		"url": null,
		"topicId": 0,
		"sceneryId": null,
		"location": "home",
		"type": "ARTICLE",
		"menus": []
	}, {
		"name": "链接专题",
		"level": 0,
		"articleId": 3,
		"url": null,
		"topicId": 1,
		"sceneryId": null,
		"location": "home",
		"type": "TOPIC",
		"menus": []
	}, {
		"name": "自定义链接",
		"level": 0,
		"articleId": 0,
		"url": "http://www.sjtu.edu.cn",
		"topicId": 0,
		"sceneryId": null,
		"location": null,
		"type": "URL",
		"menus": []
	}, {
		"name": "父级菜单",
		"level": 0,
		"articleId": 0,
		"url": null,
		"topicId": 0,
		"sceneryId": null,
		"location": "father",
		"type": "PARENT",
		"menus": [{
			"name": "子级菜单",
			"level": 1,
			"articleId": 4,
			"url": null,
			"topicId": 0,
			"sceneryId": null,
			"location": "child",
			"type": "ARTICLE",
			"menus": []
		}]
	}, {
		"name": "自定义页面",
		"level": 0,
		"articleId": 0,
		"url": null,
		"topicId": 0,
		"sceneryId": 1,
		"location": "custom",
		"type": "SCENERY",
		"menus": []
	}, {
		"name": "有内容父级",
		"level": 0,
		"articleId": 5,
		"url": null,
		"topicId": 0,
		"sceneryId": null,
		"location": "parent",
		"type": "ARTICLE",
		"menus": [{
			"name": "儿子",
			"level": 1,
			"articleId": 5,
			"url": null,
			"topicId": 0,
			"sceneryId": null,
			"location": "child",
			"type": "ARTICLE",
			"menus": []
		}]
	}],
	"poster": {
		"id": 49,
		"sort": null,
		"createTime": "2017-03-09 06:47:31",
		"updateTime": "2017-03-09 06:47:31",
		"name": "logo.png",
		"code": "e8be82e77985bf4a96d1517e36f40067",
		"size": 15579,
		"type": "image/png",
		"filter": "image",
		"privacy": false,
		"url": "http://aitritank.innoxyz.com/f/mic/20170309/e8be82e77985bf4a96d1517e36f40067/logo.png",
		"status": "OK"
	}
};

export default json;


// WEBPACK FOOTER //
// ./src/common/store/Theme1TopicJson.js